module.exports = __webpack_public_path__ + "static/media/customizationActive.9558bbce.svg";